import { CheckoutOptimizationWidgetType } from "@redotech/redo-model/checkouts/widget";
import { MercuryModelMode } from "@redotech/redo-model/conversion/mercury-model";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCheckoutExperiences = {
  name: "getCheckoutExperiences" as const,
  input: z.object({ active: z.boolean().optional() }),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string(),
      active: z.boolean(),
      rateTables: z.array(
        z.object({
          _id: zExt.objectId(),
          name: z.string(),
          description: z.string(),
          priceDisplayPlaceholder: z.string(),
        }),
      ),
      widgets: z.array(createEnum(CheckoutOptimizationWidgetType)),
      mercury: z
        .object({
          currentModelId: zExt.objectId(),
          mode: createEnum(MercuryModelMode),
        })
        .optional(),
    }),
  ),
};
export type GetCheckoutExperiencesOutput = z.infer<
  typeof getCheckoutExperiences.output
>;
